import { render } from "./ModalAddProductsComp.vue?vue&type=template&id=7428301a"
import script from "./ModalAddProductsComp.vue?vue&type=script&lang=js"
export * from "./ModalAddProductsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__